import axios from 'api';
import { isAxiosError } from 'axios';
import APIError from 'types/api/error';

/**
 * 쓰기 요청(생성·수정·삭제)에 거는 응답 대기 상한. 프록시·보안 장비가 요청
 * 본문을 삼키면 서버(nginx)는 60초 뒤에야 연결을 끊는다 — 그 전에 사용자에게
 * 실패를 알리기 위한 값. 조회 요청은 긴 쿼리가 있어 적용하지 않는다.
 */
export const WRITE_REQUEST_TIMEOUT_MS = 30_000;

/** 서버 도달 여부 확인(GET /version)에 허용하는 시간. */
export const REACHABILITY_TIMEOUT_MS = 5_000;

/** 서버가 아무 응답도 주지 않았을 때 axios 가 붙이는 코드들. */
export const NETWORK_ERROR_CODES = [
	'ERR_NETWORK',
	'ECONNABORTED',
	'ETIMEDOUT',
] as const;

/** 요청이 서버 응답 없이 끝났는지(연결 끊김·타임아웃) 판정한다. */
export function isNetworkError(
	error: APIError | { code?: string | number } | null | undefined,
): boolean {
	if (!error) {
		return false;
	}
	const code = error instanceof APIError ? error.getErrorCode() : error.code;
	return (NETWORK_ERROR_CODES as readonly string[]).includes(String(code));
}

/**
 * 서버가 살아 있는지 본문 없는 GET 으로 확인한다. 어떤 HTTP 응답이든 오면
 * 도달한 것(401·500 포함) — 실패는 연결 자체가 안 될 때뿐이다. 본문 있는 요청만
 * 막는 프록시 문제와 서버 다운을 가르는 용도.
 */
export async function checkServerReachable(): Promise<boolean> {
	try {
		await axios.get('/version', { timeout: REACHABILITY_TIMEOUT_MS });
		return true;
	} catch (error) {
		return isAxiosError(error) && Boolean(error.response);
	}
}
